import { trackSignupEvent } from '../../../utlis/useAnalytics';
import Eximpe from "../assets/EximPe-White.svg";
import Btn from "../resuable-components/Button"
export default function FeeComparison(){

  const btnClick = () => {
    trackSignupEvent({
      page: 'Global Collection Page',
      section: 'Fee Comparision',
    });
  };
  
    return(
        <div className="mt-[140px] lg:px-[10%]  px-4">
        <p className="text-4xl text-[#1A202C] font-bold text-center">
          Lowest Fees, Unmatched Savings
        </p>
        <p className="text-2xl text-[#6a7282] text-center mt-[30px]">
          No hidden charges or FX markups—get even lower rates as your transaction volume grows!
        </p>
        <div className="mt-[60px] px-[10%]">
          {/* Desktop Table */}
          <div className="hidden lg:block">
            <div className="bg-[#213248] p-8 rounded-3xl overflow-hidden">
              <div className="overflow-x-auto">
                <table className="w-full md:min-w-[600px]">
                  <thead className="md:table-header-group">
                    <tr className="">
                      <th className="py-3 px-4 text-left font-medium text-white "></th>
                      <th className="py-3 px-4 text-center font-medium text-white ">
                        Banks
                      </th>
                      <th className="py-3 px-4 text-center font-medium text-white ">
                        Paypal
                      </th>
                      <th className="py-3 px-4 text-center font-medium text-white ">
                        Others
                      </th>
                      <th className="bg-[#394a5f] pt-5 pb-5 rounded-t-2xl px-4 text-center font-medium text-white">
                        <img src={Eximpe} alt="Eximpe Logo" className="w-30 mx-auto" />
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {/* Transaction Fees Row */}
                    <tr className="flex flex-col md:table-row">
                      <td className="py-4 px-4 text-left text-[#b1b5b9] flex flex-col items-center md:table-cell ">
                        Txn Fees
                      </td>
                      <td className="py-4 px-4 text-center text-white flex flex-col items-center  md:table-cell ">
                        <span>$20–$40</span>
                      </td>
                      <td className="py-4 px-4 text-center text-white flex flex-col items-center md:table-cell ">
                        <span>4.4% + $0.30</span>
                      </td>
                      <td className="py-4 px-4 text-center text-white flex flex-col items-center  md:table-cell ">
                        <span>1% + $3</span>
                      </td>
                      <td className="bg-[#394a5f] py-4 px-4 text-center text-white flex flex-col items-center  md:table-cell">
                        <span>0.75% + $0.5</span>
                      </td>
                    </tr>
                    
                    {/* FX Spread Row */}
                    <tr className="flex flex-col md:table-row border-b-3 border-[#64717a]">
                      <td className="py-4 px-4 text-left text-[#b1b5b9] flex flex-col items-center md:table-cell ">
                        FX Spread
                      </td>
                      <td className="py-4 px-4 text-center text-white flex flex-col items-center  md:table-cell ">
                        <span>1.5%–3.0%</span>
                      </td>
                      <td className="py-4 px-4 text-center text-white flex flex-col items-center  md:table-cell ">
                        <span>4%</span>
                      </td>
                      <td className="py-4 px-4 text-center text-white flex flex-col items-center  md:table-cell ">
                        <span>3%</span>
                      </td>
                      <td className="bg-[#394a5f] py-4 px-4 text-center text-white flex flex-col items-center  md:table-cell">
                        <span>0%</span>
                      </td>
                    </tr>
                    
                    {/* Total Row */}
                    <tr className="flex flex-col md:table-row">
                      <td className="py-4 px-4 text-left text-[#b1b5b9] flex flex-col items-center md:table-cell ">
                        Total
                      </td>
                      <td className="py-4 px-4 text-center text-white flex flex-col items-center  md:table-cell ">
                        <span className="whitespace-nowrap">Up to 3.0% + $40</span>
                      </td>
                      <td className="py-4 px-4 text-center text-white flex flex-col items-center md:table-cell ">
                        <span className="whitespace-nowrap">8.4% + $0.30</span>
                      </td>
                      <td className="py-4 px-4 text-center text-white flex flex-col items-center  md:table-cell ">
                        <span className="whitespace-nowrap">4% + $3</span>
                      </td>
                      <td className="bg-[#394a5f] py-4 px-4 text-center text-white flex flex-col items-center  md:table-cell">
                        <span>0.75% + $0.5</span>
                      </td>
                    </tr>
                    
                    {/* Desktop Sign Up Button in Eximpe Column */}
                    <tr className="hidden md:table-row">
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td className="py-6 px-4 flex items-center justify-center rounded-b-2xl bg-[#394a5f]">
                        <Btn/>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Mobile Cards */}
          <div className="block lg:hidden space-y-4">
            {/* Txn Fees Section */}
            <div className="bg-[#213248] p-4 rounded-lg">
              <h3 className="text-white text-lg font-bold mb-2">Txn Fees</h3>
              <div className="space-y-2">
                <div className="flex justify-between border-b border-gray-700 pb-2">
                  <span className="text-white">Banks</span>
                  <span className="text-white">$20–$40</span>
                </div>
                <div className="flex justify-between border-b border-gray-700 pb-2">
                  <span className="text-white">Paypal</span>
                  <span className="text-white">4.4% + $0.30</span>
                </div>
                <div className="flex justify-between border-b border-gray-700 pb-2">
                  <span className="text-white">Others</span>
                  <span className="text-white">1% + $3</span>
                </div>
                <div className="flex justify-between items-center">
                  <img src={Eximpe} alt="Eximpe Logo" className="w-20" />
                  <span className="text-white">0.75% + $0.5</span>
                </div>
              </div>
            </div>
            
            {/* FX Spread Section */}
            <div className="bg-[#213248] p-4 rounded-lg">
              <h3 className="text-white text-lg font-bold mb-2">FX Spread</h3>
              <div className="space-y-2">
                <div className="flex justify-between border-b border-gray-700 pb-2">
                  <span className="text-white">Banks</span>
                  <span className="text-white">1.5%–3.0%</span>
                </div>
                <div className="flex justify-between border-b border-gray-700 pb-2">
                  <span className="text-white">Paypal</span>
                  <span className="text-white">4%</span>
                </div>
                <div className="flex justify-between border-b border-gray-700 pb-2">
                  <span className="text-white">Others</span>
                  <span className="text-white">3%</span>
                </div>
                <div className="flex justify-between items-center">
                  <img src={Eximpe} alt="Eximpe Logo" className="w-20" />
                  <span className="text-white">0%</span>
                </div>
              </div>
            </div>
            
            {/* Total Section */}
            <div className="bg-[#213248] p-4 rounded-lg">
              <h3 className="text-white text-lg font-bold mb-2">Total</h3>
              <div className="space-y-2">
                <div className="flex justify-between border-b border-gray-700 pb-2">
                  <span className="text-white">Banks</span>
                  <span className="text-white whitespace-nowrap">Up to 3.0% + $40</span>
                </div>
                <div className="flex justify-between border-b border-gray-700 pb-2">
                  <span className="text-white">Paypal</span>
                  <span className="text-white whitespace-nowrap">8.4% + $0.30</span>
                </div>
                <div className="flex justify-between border-b border-gray-700 pb-2">
                  <span className="text-white">Others</span>
                  <span className="text-white whitespace-nowrap">4% + $3</span>
                </div>
                <div className="flex justify-between items-center">
                  <img src={Eximpe} alt="Eximpe Logo" className="w-20" />
                  <span className="text-white">0.75% + $0.5</span>
                </div>
              </div>
            </div>
            
            {/* Mobile Sign Up Button */}
            <div className="flex justify-center">
            <Btn onClick={btnClick}/>
              
            </div>
          </div>
        </div>
      </div>
    )
}